module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-black-3a7a86b48391cad9b6add363465e25d4.svg";